import { FC } from "react";
import { DialogData, DialogHandle } from "../../types";
import { useApp } from "../../context/useApp";
import { Icon } from "../../parts/Icon";
import { DEFAULT_DIALOG_HANDLE } from "../../utils/symbols";
import { _ } from "../../utils/helpers";

interface SelectShiftFirstDialogProps {
    dialogData: DialogData
}

export const SelectShiftFirstDialog: FC<SelectShiftFirstDialogProps> = ({dialogData}) => {

    const {state: {
        dialogHandles
    }} = useApp()

    if (dialogData.dialog !== 'select-shift-first') return null

    const dialogHandle:DialogHandle = dialogHandles.get('table-map-dialog') ?? DEFAULT_DIALOG_HANDLE

    return (
        <section className="h-100 w-100">
            <div className="pointer-container df aic p-a">
                <p className="instruction-text mr-4 mt-3">{_('2di_selec_q')}</p>
                <Icon icon="pointer"/>
            </div>
        </section>
    )
}